import * as React from "react"
import ElemCheckboxMafo from "../../elements/CheckboxMafo"
import { watch } from "fs/promises"

interface MafoQuestionProps {
	register: Function
	errors: any
	watch: Function
	setValue: Function
}
const MafoQuestionFive: React.FC<MafoQuestionProps> = ({ register, errors, watch, setValue }) => {
	const questionFiveValue = watch("question5")
	const hasOtherOptionSelected = Array.isArray(questionFiveValue) ? questionFiveValue.includes("k") : questionFiveValue === "k"

	React.useEffect(() => {
		if (!hasOtherOptionSelected) {
			setValue("question5Other", "")
		}
	}, [hasOtherOptionSelected, setValue])
	return (
		<>
			<h3 className="mafo-headline text-left text-blue">5. Welche Kriterien sind Dir bei der Auswahl von Protein- oder Müsliriegeln generell wichtig? (Mehrfachauswahl möglich)</h3>
			<div className="mx-auto text-left lg:max-w-[100%] pt-1">
				<ElemCheckboxMafo label={<>Hoher Proteingehalt</>} className=" question5 pb-2 text-green">
					<input type="checkbox" {...register("question5")} name="question5" value="a" className={"peer absolute hidden h-1 w-1 " + (errors.question5 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Vegan / pflanzlich</>} className=" question5 pb-2 text-green">
					<input type="checkbox" {...register("question5")} name="question5" value="b" className={"peer absolute hidden h-1 w-1 " + (errors.question5 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Wenig Zucker / zuckerreduziert</>} className=" question5 pb-2 text-green">
					<input type="checkbox" {...register("question5")} name="question5" value="c" className={"peer absolute hidden h-1 w-1 " + (errors.question5 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Guter Geschmack</>} className=" question5 pb-2 text-green">
					<input type="checkbox" {...register("question5")} name="question5" value="d" className={"peer absolute hidden h-1 w-1 " + (errors.question5 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Gutes Preis-Leistungs-Verhältnis</>} className=" question5 pb-2 text-green">
					<input type="checkbox" {...register("question5")} name="question5" value="e" className={"peer absolute hidden h-1 w-1 " + (errors.question5 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Hoher Ballaststoffgehalt</>} className=" question5 pb-2 text-green">
					<input type="checkbox" {...register("question5")} name="question5" value="f" className={"peer absolute hidden h-1 w-1 " + (errors.question5 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Natürliche Zutaten</>} className=" question5 pb-2 text-green">
					<input type="checkbox" {...register("question5")} name="question5" value="g" className={"peer absolute hidden h-1 w-1 " + (errors.question5 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Gerade im Angebot/ Werbung im Geschäft</>} className=" question5 pb-2 text-green">
					<input type="checkbox" {...register("question5")} name="question5" value="h" className={"peer absolute hidden h-1 w-1 " + (errors.question5 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Empfehlung von Freunden oder Influencern</>} className=" question5 pb-2 text-green">
					<input type="checkbox" {...register("question5")} name="question5" value="i" className={"peer absolute hidden h-1 w-1 " + (errors.question5 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Nachhaltigkeit</>} className=" question5 pb-2 text-green">
					<input type="checkbox" {...register("question5")} name="question5" value="j" className={"peer absolute hidden h-1 w-1 " + (errors.question5 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Sonstiges</>} className=" question5 pb-2 text-green">
					<input type="checkbox" {...register("question5")} name="question5" value="k" className={"peer absolute hidden h-1 w-1 " + (errors.question5 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				{hasOtherOptionSelected && (
					<>
						<textarea {...register("question5Other")} name="question5Other" maxLength={99} className="h-[150px] w-full bg-[#F7F7F7] py-4 px-2 border-blue border-[1px]"></textarea>
					</>
				)}
			</div>
		</>
	)
}

export default MafoQuestionFive
